import { Message } from "element-ui";
import commonRender from "@/CommonDP/pages/commonRender/index.vue";
import commonRouterView from "@/CommonDP/pages/commonRender/commonRouterView.vue";
import templateRender1 from "@/CommonDP/pages/commonRender/templateComponents/template1";
import resources from "@/CommonDP/service/admin/resources-service";
import applicationCommon from "@/CommonDP/pages/mainMg/application/common/index.vue";
import globalParams from "./globalParams";
import routerInit from "../router";
const { getDynamicIconPath } = require("@/CommonDP/utils/publicConfig");

export const DYNAMIC_ROUTES_TYPE = {
  SYS: "dynamicRoutes", // 系统动态路由
  PRJ: "PrjDynamicRoutes" // 项目动态路由
};
// 排序处理，后端返回的数据带有一个sortNo属性，可以排序

// 处理平级路由为树结构
function toTree(data) {
  const result = [];
  const map = {};
  data.forEach((item) => {
    map[item.permissionId] = item;
  });
  data.forEach((item) => {
    const parent = map[item.pid];
    if (parent) {
      (parent.childList || (parent.childList = [])).push(item);
    } else if (item.pid === "0") {
      result.push(item);
    }
  });
  return result;
}

function getParentName(pid, serveRoutes, type) {
  if (pid === "0") {
    if (type === DYNAMIC_ROUTES_TYPE.SYS) {
      return "mainMg";
    } else {
      return "project";
    }
  } else {
    return serveRoutes.find((item) => item.permissionId === pid)?.permissionKey;
  }
}
function getRootParentName(id, serveRoutes, type) {
  const target = getRootTarget(id, serveRoutes);
  return target?.permissionName || "";
}
function getRootTarget(id, serveRoutes, type) {
  const arr = [id];
  let result;
  while (arr.length > 0) {
    const targetId = arr.shift();
    const t = serveRoutes.find((item) => item.permissionId === targetId);
    //  如果还有 pid 的时候，继续寻找父级
    result = t;
    if (t && t.pid && t.pid !== "0") {
      arr.push(t.pid);
    }
  }
  return result;
}

//
//
/**
 * 在这里处理动态路由 注意处理树状结构路由
 * @param serveRoutes
 * @param type dynamicRoutes 系统权限 ,PrjDynamicRoutes 项目权限
 */
function saveDynamicRouteToStorage(serveRoutes, type = DYNAMIC_ROUTES_TYPE.SYS) {
  const routes = serveRoutes
    .filter(({ dynamicRouter, resourceType }) => dynamicRouter && resourceType !== 1)
    .map((item) => {
      const rootPname = getRootParentName(item.pid, serveRoutes, item.permissionKey);
      const dyItem = {
        pid: item.pid,
        permissionId: item.permissionId,
        name: getParentName(item.pid, serveRoutes, type),
        resourceType: item.resourceType,
        config: {
          path: item.location,
          name: item.permissionKey,
          meta: {
            // 关联表
            relateId: item.permissionKey,
            // 关联type 根据关联type指定渲染组件（table form等）
            useTemplate: item.useTemplate,
            type: item.renderType,
            pname: rootPname,
            ppname: rootPname,
            // pname: type === DYNAMIC_ROUTES_TYPE.PRJ ? '项目' : '',
            // ppname: type === DYNAMIC_ROUTES_TYPE.PRJ ? '项目' : '',
            prouteName: item.permissionName,
            routeName: item.permissionName
          }
        }
      };
      if (item.icon) {
        dyItem.config.meta.icon = item.icon;
        dyItem.config.meta.icon1 = item.icon1;
        dyItem.config.meta.icon2 = item.icon2;
      }
      return dyItem;
    });
  const finalRoutes = [];
  const map = {};
  routes.forEach((item) => {
    map[item.permissionId] = item;
  });
  routes.forEach((item) => {
    const parent = map[item.pid];
    if (parent) {
      (parent.childList || (parent.childList = [])).push(item);
    } else if (item.name) {
      finalRoutes.push(item);
    }
  });
  addDynamicToVueRouter(type, finalRoutes);
}

// 系统权限
export const handleRoute = function (serveRoutes) {
  const store = require("@/store/index").default;
  const flatRoutes = []; // 后端serveRoutes返回平级所有有权限的不完整路由数组，匹配本地创造完整路由对象
  let routes = []; // 最终树形路由
  const array1 = serveRoutes.filter(({ isShow }) => isShow === 1);
  const array = array1.filter(({ permissionName }) => permissionName !== "暂无项目");
  const list2 = array.filter(({ resourceType }) => resourceType !== 1);
  const list = list2.filter(
    ({ permissionKey }) => permissionKey !== "allEnterpriseDeptDoc" && permissionKey !== "affiliationEnterpriseDeptDoc" && permissionKey !== "enterpriseDeptRecycle"
  );
  const buttonList = array.filter(({ resourceType }) => resourceType === 1);
  store.commit("saveAuthButtons", buttonList);
  for (const moduleItem of list) {
    const it = {
      ...moduleItem,
      childList: moduleItem.resourceType === 2 ? null : []
    };
    if (!it.iconPath) {
      it.icon = resources.getResourceInActiveIconUrl(moduleItem.permissionId);
      it.icon1 = resources.getResourceInActiveIconUrl(moduleItem.permissionId);
      it.icon2 = resources.getResourceActiveIconUrl(moduleItem.permissionId);
    }
    flatRoutes.push(it);
  }
  addApplicationsRoutes(flatRoutes);
  saveDynamicRouteToStorage(flatRoutes);
  routes = toTree(flatRoutes);
  store.commit("saveFlatRoutes", flatRoutes);
  store.commit("saveAuthRoutes", routes);
  return routes;
};
// 项目权限
export const handleProjectRoute = function (serveRoutes) {
  const store = require("@/store/index").default;
  const flatProjectRoutes = []; // 后端serveRoutes返回平级所有有权限的不完整路由数组，匹配本地创造完整路由对象
  let routes = []; // 最终树形路由
  const array = serveRoutes.filter(({ isShow }) => isShow === 1);
  const list = array.filter(({ resourceType }) => resourceType !== 1);
  const buttonList = array.filter(({ resourceType }) => resourceType === 1);
  store.commit("saveAuthProjectButtons", buttonList);
  for (const moduleItem of list) {
    const it = {
      ...moduleItem,
      childList: moduleItem.resourceType === 2 ? null : []
    };
    if (!it.iconPath) {
      it.icon = resources.getResourceInActiveIconUrl(moduleItem.permissionId);
      it.icon1 = resources.getResourceInActiveIconUrl(moduleItem.permissionId);
      it.icon2 = resources.getResourceActiveIconUrl(moduleItem.permissionId);
    }
    flatProjectRoutes.push(it);
  }
  addApplicationsRoutes(flatProjectRoutes);
  saveDynamicRouteToStorage(flatProjectRoutes, DYNAMIC_ROUTES_TYPE.PRJ);
  routes = toTree(flatProjectRoutes);
  store.commit("saveFlatProjectRoutes", flatProjectRoutes);
  store.commit("saveAuthProjectRoutes", routes);
  return routes;
};

// .获取用户按钮权限
export function checkPermission(value) {
  const store = require("@/store/index").default;
  let isExist = false;
  const dynamicSysButtons = store.state.router.buttonRoutes;
  const dynamicProjectButtons = store.state.router.buttonProjectRoutes;
  const dynamicButtons = dynamicSysButtons.concat(dynamicProjectButtons);
  if (dynamicButtons === undefined || dynamicButtons === null || dynamicButtons.length < 1) {
    return isExist;
  }
  dynamicButtons.map((item) => {
    if (item.permissionKey === value) {
      isExist = true;
      return isExist;
    }
  });
  return isExist;
}

// 使用企业禁止部分功能
export function disablePrompt() {
  const store = require("@/store/index").default;
  const isTrial = store.state.enterprise.isTrial;
  if (isTrial && isTrial.toString() === "1") {
    Message({
      message: "请加入正式企业后，再体验该功能",
      type: "warning",
      duration: 3 * 1000
    });
    return false;
  } else {
    return true;
  }
}
export function isTrialshow() {
  const store = require("@/store/index").default;
  const isTrial = store.state.enterprise.isTrial;
  if (isTrial && isTrial.toString() === "1") {
    return false;
  } else {
    return true;
  }
}

export function addDynamicToVueRouter(key, routes) {
  // const dyStr = localStorage.getItem(key);
  // if (!dyStr) {
  //   return;
  // }
  // const routes = JSON.parse(dyStr);
  const router = routerInit();
  function addRoute(routes, parent = []) {
    const all = router.getRoutes();
    if (Array.isArray(routes)) {
      routes.map((item) => {
        let com;
        const isAppend = all.find((it) => it.name === item.config.name);
        if (!isAppend) {
          // 先处理使用模板的情况
          if (item.config.meta.useTemplate) {
            let templateId = item.config.meta.relateId;
            const randomNumber = templateId.split("__").at(-1);
            var reg = new RegExp(`__${randomNumber}`);
            templateId = templateId.replace(reg, "");
            switch (templateId) {
              case "1":
                com = templateRender1;
                break;
              default:
                com = templateRender1;
                break;
            }
          } else if (item.config.meta.type) {
            com = commonRender;
          } else {
            com = commonRouterView;
          }
          router.addRoute(item.name || getParentName(item.pid, parent), { ...item.config, component: com });
        }
        if (item.childList?.length) addRoute(item.childList, item);
      });
    }
  }
  addRoute(routes);
}

function addApplicationsRoutes(flatRoute) {
  const router = routerInit();
  // 处理应用下的一级路由
  flatRoute.map((route) => {
    if (/^\/application-/g.test(route.location)) {
      const children = [];
      // 筛选非动态路由，动态路由由addDynamicToVueRouter自动添加
      flatRoute
        .filter((item) => item.pid === route.permissionId && !item.dynamicRouter)
        .map((item) => {
          children.push({
            path: item.location,
            name: item.permissionKey,
            component: globalParams.get(`${route.permissionKey}.${item.permissionKey}`),
            meta: {
              routeName: item.permissionName,
              prouteName: route.permissionName,
              ppname: "应用"
            }
          });
        });
      router.addRoute("application", {
        path: route.location,
        name: route.permissionKey,
        component: applicationCommon,
        children,
        meta: {
          pname: "应用"
        }
      });
    }
  });
}
